import React, { useRef, useState, useEffect } from 'react';
import TablaUTE from './tablaute';

export const UTE = (props) => {

    return (
        <div className='container-fluid rounded'>
           <div className='container-fluid w-100 h-100'>
               <TablaUTE/>
           </div>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/valorute.js